import { render, staticRenderFns } from "./SPRSimpleText.vue?vue&type=template&id=227cd983&scoped=true"
import script from "./SPRSimpleText.vue?vue&type=script&lang=js"
export * from "./SPRSimpleText.vue?vue&type=script&lang=js"
import style0 from "./SPRSimpleText.vue?vue&type=style&index=0&id=227cd983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227cd983",
  null
  
)

export default component.exports